// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var nbsp = String.fromCharCode(160);

var circleChar = String.fromCharCode(9679);

var MmException = /* @__PURE__ */Caml_exceptions.create("Common.MmException");

function panic(msg) {
  throw {
        RE_EXN_ID: MmException,
        _1: {
          msg: msg
        },
        Error: new Error()
      };
}

function jsErrorToExnData(exn) {
  var jsExn = Caml_js_exceptions.as_js_exn(exn);
  return {
          exn: exn,
          msg: Core__Option.getOr(Core__Option.flatMap(jsExn, (function (prim) {
                      return prim.message;
                    })), "Unknown error."),
          stack: Core__Option.getOr(Core__Option.flatMap(jsExn, (function (prim) {
                      return prim.stack;
                    })), "")
        };
}

function catchExn(run) {
  try {
    return {
            TAG: "Ok",
            _0: run()
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === MmException) {
      return {
              TAG: "Error",
              _0: {
                exn: undefined,
                msg: exn._1.msg,
                stack: ""
              }
            };
    } else {
      return {
              TAG: "Error",
              _0: jsErrorToExnData(exn)
            };
    }
  }
}

function currTimeStr() {
  return new Date(Date.now()).toISOString();
}

function compareDates(a, b) {
  var t1 = a.getTime();
  var t2 = b.getTime();
  if (t1 < t2) {
    return -1.0;
  } else if (t2 < t1) {
    return 1.0;
  } else {
    return 0.0;
  }
}

function floatToPctStr(pct) {
  return String(Math.round(pct * 100) | 0) + "%";
}

function cacheMake(recalc, depVerEq) {
  return {
          recalc: recalc,
          depVerEq: depVerEq,
          depVer: undefined,
          data: undefined
        };
}

function cacheGetByDepVer(cache, depVer) {
  var cachedDepVer = cache.depVer;
  if (cachedDepVer !== undefined && cache.depVerEq(Caml_option.valFromOption(cachedDepVer), depVer)) {
    return cache.data;
  }
  
}

function cacheGet(cache, depVer, dep) {
  var data = cacheGetByDepVer(cache, depVer);
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  }
  cache.depVer = Caml_option.some(depVer);
  var data$1 = cache.recalc(dep);
  cache.data = Caml_option.some(data$1);
  return data$1;
}

function strToRegex(str) {
  try {
    return {
            TAG: "Ok",
            _0: new RegExp(str)
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    return {
            TAG: "Error",
            _0: Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_js_exceptions.as_js_exn(exn), (function (prim) {
                        return prim.message;
                      })), "could not create a regular expression from string '" + str + "'")
          };
  }
}

function splitByRegex(str, regex) {
  return str.split(regex).map(function (strOpt) {
                return Belt_Option.getWithDefault(strOpt, "").trim();
              }).filter(function (str) {
              return str.length > 0;
            });
}

var newLineRegex = /[\n\r]/;

function multilineTextToNonEmptyLines(__x) {
  return splitByRegex(__x, newLineRegex);
}

var whitespaceDelimRegex = /[\s\n\r\f]/;

function getSpaceSeparatedValuesAsArray(__x) {
  return splitByRegex(__x, whitespaceDelimRegex);
}

var plusSignRegex = /\+/g;

var minusSignRegex = /-/g;

var forwardSlashSignRegex = /\//g;

var underscoreSignRegex = /_/g;

function strToSafeBase64(str) {
  return btoa(str).replace(plusSignRegex, "-").replace(forwardSlashSignRegex, "_");
}

function safeBase64ToStr(safeBase64) {
  return atob(safeBase64.replace(underscoreSignRegex, "/").replace(minusSignRegex, "+"));
}

function versionMake(val) {
  return {
          ver: 0,
          val: val
        };
}

function versionSet(version, newVal) {
  return {
          ver: version.ver + 1 | 0,
          val: newVal
        };
}

function arrayQueueMake(initSize) {
  var data = new Array(initSize);
  return {
          begin: 0,
          end: -1,
          maxEnd: data.length - 1 | 0,
          data: data
        };
}

function arrayQueueAdd(q, elem) {
  if (q.end === q.maxEnd) {
    console.log("q.end == q.maxEnd");
    q.data = Belt_Array.concat(q.data, new Array(q.data.length));
    q.maxEnd = q.data.length - 1 | 0;
  }
  q.end = q.end + 1 | 0;
  q.data[q.end] = elem;
}

function arrayQueuePop(q) {
  if (q.begin > q.end) {
    return ;
  }
  var res = q.data[q.begin];
  q.begin = q.begin + 1 | 0;
  return Caml_option.some(res);
}

function arrayQueueReset(q) {
  q.begin = 0;
  q.end = -1;
}

function createVarTypeComparator(varTypes, typeOrder) {
  var varOrderByType = Belt_HashMapInt.make(Belt_HashMapInt.size(varTypes));
  Belt_HashMapInt.forEach(varTypes, (function ($$var, typ) {
          var tOrder = Belt_HashMapInt.get(typeOrder, typ);
          if (tOrder !== undefined) {
            return Belt_HashMapInt.set(varOrderByType, $$var, tOrder);
          }
          
        }));
  return function (a, b) {
    var aTypOrder = Belt_HashMapInt.get(varOrderByType, a);
    if (aTypOrder !== undefined) {
      var bTypOrder = Belt_HashMapInt.get(varOrderByType, b);
      if (bTypOrder !== undefined) {
        return Caml.int_compare(aTypOrder, bTypOrder);
      } else {
        return -1.0;
      }
    }
    var match = Belt_HashMapInt.get(varOrderByType, b);
    if (match !== undefined) {
      return 1.0;
    } else {
      return 0.0;
    }
  };
}

function createVarNameComparator(varNames) {
  return function (a, b) {
    var aStr = Belt_HashMapInt.get(varNames, a);
    if (aStr !== undefined) {
      var bStr = Belt_HashMapInt.get(varNames, b);
      if (bStr !== undefined) {
        return aStr.localeCompare(bStr);
      } else {
        return -1.0;
      }
    }
    var match = Belt_HashMapInt.get(varNames, b);
    if (match !== undefined) {
      return 1.0;
    } else {
      return 0.0;
    }
  };
}

function createTypeOrderFromStr(sortDisjByType, typeNameToInt) {
  var typeOrderInDisj = Belt_HashMapInt.make(4);
  getSpaceSeparatedValuesAsArray(sortDisjByType).forEach(function (typStr) {
        var i = typeNameToInt(typStr);
        if (i !== undefined) {
          return Belt_HashMapInt.set(typeOrderInDisj, i, Belt_HashMapInt.size(typeOrderInDisj));
        }
        
      });
  return typeOrderInDisj;
}

function strToBase64(prim) {
  return btoa(prim);
}

function base64ToStr(prim) {
  return atob(prim);
}

exports.nbsp = nbsp;
exports.circleChar = circleChar;
exports.MmException = MmException;
exports.panic = panic;
exports.jsErrorToExnData = jsErrorToExnData;
exports.catchExn = catchExn;
exports.currTimeStr = currTimeStr;
exports.compareDates = compareDates;
exports.floatToPctStr = floatToPctStr;
exports.cacheMake = cacheMake;
exports.cacheGetByDepVer = cacheGetByDepVer;
exports.cacheGet = cacheGet;
exports.multilineTextToNonEmptyLines = multilineTextToNonEmptyLines;
exports.getSpaceSeparatedValuesAsArray = getSpaceSeparatedValuesAsArray;
exports.strToBase64 = strToBase64;
exports.base64ToStr = base64ToStr;
exports.strToSafeBase64 = strToSafeBase64;
exports.safeBase64ToStr = safeBase64ToStr;
exports.strToRegex = strToRegex;
exports.versionMake = versionMake;
exports.versionSet = versionSet;
exports.arrayQueueMake = arrayQueueMake;
exports.arrayQueueAdd = arrayQueueAdd;
exports.arrayQueuePop = arrayQueuePop;
exports.arrayQueueReset = arrayQueueReset;
exports.createVarTypeComparator = createVarTypeComparator;
exports.createVarNameComparator = createVarNameComparator;
exports.createTypeOrderFromStr = createTypeOrderFromStr;
/* nbsp Not a pure module */
